<template>
        <nav id="navbar" ref="navbar" class="navbar navbar-expand-lg fixed-top navbar-light pb-0 pt-0">
                <a class="navbar-brand" v-on:click="doScroll('homepage')">
                    <img src="@/assets/logo.svg" class="d-inline-block align-center custom-navbar-icon" alt="Bitcoin"/>
                </a>
                <button id="toggle-button" v-on:click="openNav()" class="navbar-toggler" type="button">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse pl-4 pr-4" id="navbarTogglerDemo02">
                    <ul class="navbar-nav mr-auto">
                        <li class="nav-item ml-2 mr-2" v-bind:class="currentTab === 'welcome-wrapper' ? 'active':''">
                            <a class="nav-link" v-on:click="setActiveRoute('welcome-wrapper')">Welcome</a>
                        </li>
                        <li class="nav-item ml-2 mr-2" v-bind:class="currentTab === 'commission-wrapper' ? 'active':''">
                            <a class="nav-link" v-on:click="setActiveRoute('commission-wrapper')">Commission</a>
                        </li>
                        <li class="nav-item ml-2 mr-2" v-bind:class="currentTab === 'whyus' ? 'active':''">
                            <a class="nav-link" v-on:click="setActiveRoute('whyus')">Why Us</a>
                        </li>
                        <li class="nav-item ml-2 mr-2" v-bind:class="currentTab === 'faq' ? 'active':''">
                            <a class="nav-link" href="/faq">F.A.Q</a>
                        </li>
                        <li class="nav-item ml-2 mr-2" v-bind:class="currentTab === 'testimonials-wrapper' ? 'active':''">
                            <a class="nav-link" v-on:click="setActiveRoute('testimonials-wrapper')">Testimonials</a>
                        </li>
                        <li class="nav-item ml-2 mr-2" v-bind:class="currentTab === 'contactus' ? 'active':''">
                            <a class="nav-link" v-on:click="setActiveRoute('contactus')">Contact Us</a>
                        </li>
                    </ul>
                    <form class="form-inline my-2 my-lg-0">
                        <button type="button" v-on:click="register()" class="btn btn-success custom-btn btn-sm my-2 my-sm-0 mr-2">REGISTER</button>
                        <button type="button" v-on:click="loginLink()" class="btn btn-outline-success custom-btn btn-sm my-2 my-sm-0">LOGIN</button>
                    </form>
                </div>
                <div id="mySidebar" class="sidebar">
                    <div class="row">
                        <div class="col-12">
                            <a href="javascript:void(0)" class="closebtn pr-4" v-on:click="closeNav()">
                                <span  class="display-3">×</span>
                            </a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <ul class="navbar-nav mr-auto">
                                <li class="nav-item ml-2 mr-2 text-center pt-0 pb-0">
                                    <a class="nav-link p-0" v-on:click="setActiveRoute('welcome-wrapper', true)">
                                        <span class="mobile-menu-text">Welcome</span>
                                    </a>
                                </li>
                                <li><hr></li>
                                <li class="nav-item ml-2 mr-2 text-center pt-0 pb-0">
                                    <a class="nav-link p-0" v-on:click="setActiveRoute('commission-wrapper', true)">
                                        <span class="mobile-menu-text">Commission</span>
                                    </a>
                                </li>
                                <li><hr></li>
                                <li class="nav-item ml-2 mr-2 text-center pt-0 pb-0">
                                    <a class="nav-link p-0" v-on:click="setActiveRoute('whyus', true)">
                                        <span class="mobile-menu-text">Why Us</span>
                                    </a>
                                </li>
                                <li><hr></li>
                                <li class="nav-item ml-2 mr-2 text-center pt-0 pb-0" v-on:click="closeNav()">
                                    <a class="nav-link p-0" href="/faq">
                                        <span class="mobile-menu-text">F.A.Q</span>
                                    </a>
                                </li>
                                <li><hr></li>
                                <li class="nav-item ml-2 mr-2 text-center pt-0 pb-0">
                                    <a class="nav-link p-0" v-on:click="setActiveRoute('contactus', true)">
                                        <span class="mobile-menu-text">Contact Us</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row pt-5">
                        <div class="col-12 text-center">
                            <button type="button" v-on:click="loginLink()" class="btn btn-outline-success custom-btn btn-lg w-50" style="border:3px solid;">LOGIN</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-center pt-3 pb-3">
                            <button v-on:click="register()" type="button" class="btn btn-success custom-btn btn-lg w-50">REGISTER</button>
                        </div>
                    </div>
                </div>
        </nav>
</template>

<script>
    import {doScroll} from '../assets/js/scroll';
    import {registrationLink} from '../assets/js/registration';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "Navbar",
        computed: mapGetters([
            'currentTab'
        ]),
        methods: {
            ...mapActions([
                'setActiveTab',
            ]),
            doScroll,
            registrationLink,
            openNav: function() {
                document.getElementById("mySidebar").style.width = "100%";
                if(document.getElementById("main") !== null) {
                    document.getElementById("main").style.marginLeft = "100%";
                }
                if(document.getElementById("tandc") !== null) {
                    document.getElementById("tandc").style.marginLeft = "100%";
                }
                if(document.getElementById("faq") !== null) {
                    document.getElementById("faq").style.marginLeft = "100%";
                }
            },
            closeNav: function () {
                document.getElementById("mySidebar").style.width = "0";
                if(document.getElementById("main") !== null) {
                    document.getElementById("main").style.marginLeft = "0";
                }
                if(document.getElementById("tandc") !== null) {
                    document.getElementById("tandc").style.marginLeft = "0";
                }
                if(document.getElementById("faq") !== null) {
                    document.getElementById("faq").style.marginLeft = "0";
                }
            },
            loginLink: function () {
                window.location.href = "https://affiliate.bitcoin.com/affiliates/Account/Login?ReturnUrl=%2Faffiliates%2F#"
            },
            setActiveRoute: function (id,isClose = false) {
                this.setActiveTab(id);
                this.$router.push({ path: '/', query: { id }})
                this.doScroll(id, isClose);
            },
            register() {
                this.setActiveTab('');
                this.registrationLink();
            }
        }
    }
</script>

<style scoped>

    @media (min-width: 576px) {
        .navbar{
            min-height: 85px;
        }

        .navbar-brand {
            padding: 0 15px;
            height: 70px;
            line-height: 70px;
        }
    }

    @media (max-width: 576px) {
        .navbar{
            min-height: 60px;
        }

        .navbar-brand {
            padding: 0 0px;
            height: 45px;
            line-height: 45px;
        }
    }

    .navbar-light {
        background-color: #013c44 !important;
        opacity: 0.9 !important;
    }

    .logo-text{
        color: #00C58A;
        font-weight: bold;
    }

    .navbar-light .navbar-nav .show >
    .nav-link, .navbar-light .navbar-nav .active >
    .nav-link, .navbar-light .navbar-nav .nav-link.show,
    .navbar-light .navbar-nav .nav-link.active {
        color: #00C58A;
        font-weight: bold;
        font-size: 0.85rem;
    }

    .nav-item.active {
        padding-bottom: 1rem;
        border-bottom: 5px solid #00C58A;
        padding-top: 1.7rem;
    }
    .nav-item {
        padding-top: 1.7rem;
        padding-bottom: 1rem;
    }

    .navbar-light .navbar-nav .nav-link{
        color: white;
        font-weight: bold;
        font-size: 0.85rem;
    }

    .btn-success.custom-btn {
        background-color: #00C58A;
        border-color: #00C58A;
        color: white;
        font-weight: bold;
    }

    .btn-success.custom-btn:hover {
        color: #FFFFFF;
        background-color: #00E6A1;
        border-color: #00E6A1;
    }

    .btn-outline-success.custom-btn {
        color: #00C58A;
        background-color: transparent;
        background-image: none;
        border-color: #00C58A;
        font-weight: bold;
    }

    .btn-outline-success.custom-btn:hover {
        color: #FFFFFF;
        background-color: #00E6A1;
        border-color: #00E6A1;
    }

    .navbar-light .navbar-toggler-icon {
        background-image: url("~@/assets/mobile-menu-icon.svg");
    }

    #toggle-button {
        color: transparent;
        border-color: transparent;
    }

    #toggle-button:focus, #toggle-button:active {
        outline: none !important;
        box-shadow: none !important;
    }

    .custom-navbar-icon {
        height: 80% !important;
    }

    .sidebar {
        height: 100%;
        width: 0;
        position: fixed;
        z-index: 1;
        top: 0;
        right: 0;
        background-color: #004750;
        overflow-x: hidden;
        transition: 0.5s;
    }

    .sidebar a {
        padding: 8px 8px 8px 32px;
        text-decoration: none;
        font-size: 25px;
        color: #818181;
        display: block;
        transition: 0.3s;
    }

    .sidebar a:hover {
        color: #f1f1f1;
    }

    .sidebar .closebtn {
        float: right;
        color: #00C58A;
    }

    @media screen and (max-height: 450px) {
        .sidebar a {font-size: 18px;}
    }

    .mobile-menu-text {
        font-size: calc(0.5rem + 4vmin);
        font-family: Lato;
        font-weight: 400;
    }

    hr{
        border-color: #0DE2A2;
        width: 10%;
    }

    .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
        color: #00E6A1;
        cursor: pointer;
    }
</style>